import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { Expand } from 'lucide-react';
import { ImageLightbox } from './ImageLightbox';
import { sevenIslandsPhotos, photoGroups, PhotoGroup } from '../data/sevenIslands';
type Filter = 'All' | PhotoGroup;
export function SevenIslandsGallery() {
  const [filter, setFilter] = useState<Filter>('All');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const visible = useMemo(() => filter === 'All' ? sevenIslandsPhotos : sevenIslandsPhotos.filter(p => p.group === filter), [filter]);
  const filters: Filter[] = ['All', ...photoGroups];
  return <section id="gallery" className="bg-[#0A0A0A] text-white py-24 px-6 md:px-10 scroll-mt-24" data-id="element-250" data-mp="2haehn1knv72d">
      <div className="max-w-7xl mx-auto" data-id="element-251" data-mp="2ma0xlirvj1ev">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12" data-id="element-252" data-mp="2mb2aztwd3zzr">
          <div data-id="element-253" data-mp="2qbm48mdtejgm">
            <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-254" data-mp="2q8zzsvm80k2m">
              Renderings
            </p>
            <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-255" data-mp="2ee1yzgbsexem">
              See 7 Islands
            </h2>
          </div>

          <div role="tablist" aria-label="Filter renderings" className="flex flex-wrap gap-2" data-id="element-256" data-mp="29g0d6nmz8jzg">
            {filters.map(f => {
            const active = filter === f;
            return <button key={f} role="tab" aria-selected={active} onClick={() => setFilter(f)} className={`relative px-4 py-2 text-sm whitespace-nowrap rounded-sm transition-colors duration-200 ${active ? 'text-black' : 'text-gray-300 hover:text-white border border-white/15'}`} data-id="element-257" data-mp="325pj9fejna7x">
                  {active && <motion.span layoutId="gallery-filter" className="absolute inset-0 bg-[#C5A55A] rounded-sm" transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-258" data-mp="3g1kr8q7en0wj" />}
                  <span className="relative" data-id="element-259" data-mp="14fsebjry7nyh">{f}</span>
                </button>;
          })}
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 [&>*]:mb-4" data-id="element-260" data-mp="vfdtsmmt6cw1">
          {visible.map((photo, index) => <motion.button key={photo.src} layout="position" initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25,
          delay: Math.min(index * 0.04, 0.24),
          ease: [0.23, 1, 0.32, 1]
        }} onClick={() => setLightboxIndex(index)} className="group relative block w-full overflow-hidden break-inside-avoid text-left" aria-label={`Open ${photo.title}`} data-id="element-261" data-mp="zh7ngayl6gmp" data-mpi={index}>
              <img src={photo.src} alt={photo.title} loading="lazy" className="w-full h-auto block transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-262" data-mp="47vrgh4xq46f" />
              <span className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 px-4 py-3 bg-black/65" data-id="element-263" data-mp="e59v1g5reyhb">
                <span className="font-serif text-base" data-id="element-264" data-mp="rvlqnp1jzfd7">{photo.title}</span>
                <Expand className="w-4 h-4 text-[#C5A55A] shrink-0 opacity-70 group-hover:opacity-100 transition-opacity duration-200" aria-hidden="true" data-id="element-265" data-mp="mxk60zohb7zm" />
              </span>
            </motion.button>)}
        </div>

        <p className="text-gray-500 text-sm mt-8" data-id="element-266" data-mp="33m7joqbpg7np">
          Renderings are artist's concepts and subject to change.
        </p>
      </div>

      <ImageLightbox images={visible} index={lightboxIndex} onClose={() => setLightboxIndex(null)} onChange={setLightboxIndex} data-id="element-267" data-mp="2ypqwbycbxxbo" />
    </section>;
}